var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.input.label)?_c('h3',[_vm._v(_vm._s(_vm.input.label))]):_vm._e(),_vm._v(" "),_c('div',{domProps:{"textContent":_vm._s(_vm.input.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }